import { Select, Table } from "antd";
import { getGiftCardTrans } from "../../../api/trade";
import { useQuery } from "react-query";
import { giftCardTradeColumn } from "../../customers/column";
import GiftCardDetail from "./GiftCardDetail";
import { useState } from "react";

const Giftcard = () => {
  const [open, setOpen] = useState(false);
  const [singleData, setSingleData] = useState({});
  const [transactionType, setTransactionType] = useState("");
  const [page, setPage] = useState(1);

  const { data, isLoading } = useQuery(
    ["giftcard-history", transactionType, page],
    () => getGiftCardTrans(transactionType, page),
  );

  const handleRowClick = (record) => {
    setSingleData(record || {});
    setOpen(true);
  };

  return (
    <div>
      <GiftCardDetail open={open} setOpen={setOpen} record={singleData} />
      <Select
        onSelect={(val) => setTransactionType(val)}
        placeholder="Filter By Type"
        className="my-5 w-[250px]"
      >
        <Select.Option value="buy">Buy</Select.Option>
        <Select.Option value="sell">Sell</Select.Option>
      </Select>
      <Table
        dataSource={data?.transactions || []}
        columns={giftCardTradeColumn}
        loading={isLoading}
        rowClassName="cursor-pointer hover:bg-gray-50"
        onRow={(record) => {
          return {
            onClick: () => handleRowClick(record),
          };
        }}
        pagination={{
          current: page,
          pageSize: 10,
          total: data?.total || 1,
          showSizeChanger: true,
          onChange: (newPage) => {
            setPage(newPage);
          },
        }}
      />
    </div>
  );
};

export default Giftcard;
